import profile from "../../assets/profile-img.jpg";
import { useState } from "react";
import homeIcon from "../../assets/icons/home_black_24dp.svg";

const PortfolioHome = (props) => {
  console.log(props);
  console.log("ADSdasdass");
  return (
    <header id="menu" data-aos="fade-right">
      <div>
        <img className="img-fluid rounded-circle" src={profile}></img>
        <div className="links">
          <h3>
            <a href="#header" className="home">
              {" "}
              <span class="material-icons md-24">home</span> Header
            </a>
          </h3>
          <h3>
            <a href="#about">
              {" "}
              <span class="material-icons">person</span> About
            </a>
          </h3>
          <h3>
            <a href="#about">
              {" "}
              <span class="material-icons">article</span> Resume
            </a>
          </h3>
          <h3>
            <a href="#about">
              {" "}
              <span class="material-icons">code</span> Projects
            </a>
          </h3>
          <h3>
            <a href="#about">
              {" "}
              <span class="material-icons">email</span> Contant
            </a>
          </h3>
        </div>
      </div>
    </header>
  );
};
export default PortfolioHome;

/*

*/
